module.exports = __webpack_public_path__ + "img/43.79127c54.png";